import Modal from "@mui/material/Modal";
import React from "react";
import {Box, IconButton, Stack, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Cancel01Icon, VariableIcon} from "@hugeicons/core-free-icons";
import {v4 as uuid} from "uuid";
import {VarForm} from "../vars/VarForm";
import {UI, rgba} from "../../uiTokens";
import {iconBtnSx, modalCardSx} from "../editMenuStyles";

// Selected var is the param object (or null for "create")
export const CreateVariableModal = ({open, handleClose, editParam, params = [], isForm, onUpdateParams, project, variableOptions}) => {
  const isEdit = !!editParam?.uid;

  const onSubmit = (param) => {
    let newParams = [...params];
    if (editParam?.uid) {
      newParams = newParams?.map(item => (item?.uid === param?.uid ? {...param} : {...item}));
    } else {
      param.uid = uuid();
      newParams.push({...param});
    }
    onUpdateParams(newParams);
    handleClose();
  };

  const onDelete = () => {
    const newParams = params?.filter((p) => p?.uid !== editParam?.uid);
    onUpdateParams(newParams);
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="variable-modal-title">
      <Box sx={modalCardSx}>
        <Stack direction="row" gap={1} alignItems="center" sx={{mb: 2}}>
          <Box
            sx={{
              display: "flex",
              width: 32,
              height: 32,
              borderRadius: "8px",
              alignItems: "center",
              justifyContent: "center",
              color: UI.accent,
              backgroundColor: rgba(UI.accent, 0.12),
            }}
          >
            <HugeiconsIcon icon={VariableIcon} size={18}/>
          </Box>
          <Typography id="variable-modal-title" sx={{flex: 1, fontWeight: 700, fontSize: 16, color: UI.ink}}>
            {isEdit ? "Edit variable" : "New variable"}
          </Typography>
          <IconButton size="small" onClick={handleClose} sx={iconBtnSx}>
            <HugeiconsIcon icon={Cancel01Icon} size={18}/>
          </IconButton>
        </Stack>

        <VarForm
          handleClose={handleClose}
          variableOptions={variableOptions}
          onDelete={onDelete}
          onSubmit={onSubmit}
          isForm={isForm}
          selectedParam={editParam}
          project={project}
        />
      </Box>
    </Modal>
  );
};
